import React, { useState } from 'react'
import PopupOne from './PopupOne/PopupOne'
import PopupTwo from './PopupTwo'
import PopupThree from './PopupThree'
import PopupFour from './PopupFour'
import toast from 'react-hot-toast'
import HttpClient from '../../utils/HttpClient'
import { useUserData } from '../../Providers/UserWrapper'

const PopupLayout = ({ onClose }) => {
  const { setIsLoading } = useUserData();
  const [formData, setFormData] = useState({
    icon: "",
    logo: "",
    url: "",
    email: "",
    phoneNumber: "",
    preferedDay: "",
    preferedTime: "",
    engage: "yes",
  });

  const [step, setStep] = useState(1);

  const handleNext = () => {
    setStep((s) => s + 1);
  };

  const handleSaveOnDB = async apiBody => {
    try {
      setIsLoading(true);
      const res = await HttpClient.requestData("user-setting", "POST", apiBody);
      if (res && res?.success) {
        toast.success(res?.message || "User data has been saved successfully");
        handleNext();
      } else {
        toast.error(res?.message || "something went wrong!!!");
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    } finally {
      setIsLoading(false);
    }
  };

  console.log("formData: ", formData);

  return (
    <>
      {step === 1 && <PopupOne formData={formData} setFormData={setFormData} onNext={handleNext} onClose={onClose} handleSaveOnDB={handleSaveOnDB} />}
      {step === 2 && <PopupTwo formData={formData} setFormData={setFormData} onNext={handleNext} onClose={onClose} />}
      {step === 3 && <PopupThree formData={formData} setFormData={setFormData} onNext={handleNext} onClose={onClose} handleSaveOnDB={handleSaveOnDB} />}
      {step == 4 && <PopupFour formData={formData} setFormData={setFormData} onClose={onClose} />}
    </>
  )
}

export default PopupLayout